import { snapshot } from 'valtio';
import ConnectorConfigureFormStore from '../stores/connector-configure-form-store';
import ConnectorConfigureStore from '../stores/connector-configure-store';
import {
  setIsLoadingDeleteCredentials,
  setIsLoadingVerifyAndSaveCredentials,
} from './connector-configure-actions';
import { addCredentials, removeCredentials } from './credentials-actions';
import { getModalInitialCreds } from '../utils/credentials-utils';
import { Connector } from '../connectors-types';
import { logger } from 'logging-utils';
import {
  resetAWSExternalIdFormInput,
  resetFormInputs,
  setAwsAccessKeyInput,
  setAwsAccessSecretInput,
  setAwsExternalIdInput,
  setAwsRoleArnInput,
  setClientIdInput,
  setHostUrlInput,
  setNameInput,
  setPasswordInput,
  setSecretAccessKeyInput,
  setTenantInput,
  setTokenInput,
} from '../store-actions/connector-config-form-store-action';

export const setInitialFormValues = () => {
  const { selectedConnector } = snapshot(ConnectorConfigureStore);
  if (!selectedConnector) {
    return;
  }
  const { credentials, isOxBuiltIn, isConfigured } = selectedConnector;
  const isConnectorConfigured =
    (credentials.length > 0 || !!isOxBuiltIn) && isConfigured;
  if (isConnectorConfigured) {
    const initialValues = getModalInitialCreds(selectedConnector);
    setHostUrlInput(selectedConnector.hostURL);
    setNameInput(initialValues.name);
    setPasswordInput(initialValues.password);
    setTokenInput(initialValues.token);
    setClientIdInput(initialValues.clientId);
    setSecretAccessKeyInput(initialValues.secretKey);
    setAwsRoleArnInput(initialValues.awsRoleArn);
    setAwsExternalIdInput(initialValues.awsExternalId);
    setAwsAccessKeyInput(initialValues.awsAccessKey);
    setAwsAccessSecretInput(initialValues.awsAccessSecret);
    setTenantInput(initialValues.tenant);
  } else {
    setHostUrlInput(selectedConnector.hostURL);
  }
};

export const verifyAndAddCredentials = async () => {
  const {
    hostURL,
    token,
    password,
    name,
    clientId,
    secretKey,
    awsRoleArn,
    awsExternalId,
    awsAccessKey,
    awsAccessSecret,
    tenant,
  } = snapshot(ConnectorConfigureFormStore);

  const { selectedConnector } = snapshot(ConnectorConfigureStore);
  if (!selectedConnector) {
    return;
  }
  setIsLoadingVerifyAndSaveCredentials(true);
  const connectorEnableInput = {
    connectorID: selectedConnector.id,
    hostURL,
    credentialsType: selectedConnector.credentialsType,
    credentialsInput: {
      name,
      password,
      token,
      clientId,
      secretKey,
      awsRoleArn,
      awsExternalId,
      awsAccessKey,
      awsAccessSecret,
      tenant,
    },
  };
  await addCredentials(connectorEnableInput, selectedConnector);
};

export const removeConnectorCredentials = async () => {
  const { selectedConnector } = snapshot(ConnectorConfigureStore);
  if (!selectedConnector) {
    return;
  }
  setIsLoadingDeleteCredentials(true);
  const connectorEnableInput = {
    connectorID: selectedConnector.id,
    credentialsIndex: 0,
  };
  await removeCredentials(connectorEnableInput);
  resetFormInputs();
  resetAWSExternalIdFormInput();
};

export const redirectToIDP = (connector: Connector, isOnboarding?: boolean) => {
  const idpInfo = connector.identityProviderInfo;
  if (!idpInfo) {
    return;
  }

  const { baseURL, urlParams, scope } = idpInfo;
  const preParamsStr = urlParams.split('?')[0];
  const parsedParams = new URLSearchParams(
    urlParams.substring(urlParams.indexOf('?')),
  );
  const stateParam = parsedParams.get('state');
  if (!stateParam) {
    throw new Error(
      'No state parameter was found in identity provider URL parameters',
    );
  }
  try {
    const currState = JSON.parse(decodeURIComponent(stateParam));
    if (isOnboarding) {
      currState.onboarding = true;
    }
    parsedParams.set('state', encodeURIComponent(JSON.stringify(currState)));
  } catch (err) {
    logger.error(`Parsing IDP state params failed: ${err}`);
    throw new Error(`Parsing IDP state params failed: ${err}`);
  }
  const url = `${baseURL}${preParamsStr}?${parsedParams.toString()}&scope=${encodeURIComponent(
    scope,
  )}`;
  window.location.href = url;
};
